import gql from 'graphql-tag';

// Comments v3 (spec 2026-10-18-comments-design, plan 1): every comment of a page with author and resolution.
export default gql`
query getPageComments($pageId: Int!) {
  page_comments(where: {page_id: {_eq: $pageId}}, order_by: {created_at: asc}) {
    comment_id
    parent_id
    language_id
    anchor
    device
    body
    mentions
    suggestion
    attachments
    author_id
    created_at
    edited_at
    author {
      full_name
    }
    resolution {
      outcome
      resolved_at
      resolved_by
    }
    setup
    screenshot_url
    state {
      status
      assignee_id
    }
  }
}
`;
